import React from "react"

export const orgUXSettingsContext = React.createContext({
  preferredEnergyUnits: "kW",
  hideAdvancedGraphs: false,
  organizationName: "",
})
